import { Dashboard } from "@/components/dashboard/Dashboard/Dashboard";
import { VStack } from "@/components/layout/VStack";
import { HStack } from "@/components/layout/HStack";
import { useEffect, useRef, useState } from "react";
import { useRotations } from "../hooks/rotations/useRotations";
import { Skeleton } from "@/components/ui/Skeleton/Skeleton";
import {
  Empty,
  EmptyDescription,
  EmptyHeader,
  EmptyMedia,
  EmptyTitle,
} from "@/components/ui/Empty/Empty";
import { CalendarSync } from "lucide-react";
import { RotationsTable } from "../components/rotations/RotationsDataTable";
import { CreateExplorationSheet } from "../components/rotations/CreateExplorationSheet";
import { useExplorataions } from "../hooks/rotations/useExplorations";
import { ArchiveToggleButton } from "@/components/elements/ArchiveToggleButton/ArchiveToggleButton";

const TeacherRotations = ({
  archived = false,
}: {
  archived?: boolean;
}) => {
  const [open, setOpen] = useState<{ open: boolean; rotation: any }>({
    open: false,
    rotation: undefined,
  });
  const [rotations, setRotations] = useState<{
    rotations: any[];
    sessions: any[];
  }>({ rotations: [], sessions: [] });
  const [teachers, setTeachers] = useState<any[]>([]);

  const { loadRotations, loading } = useRotations({ archived });
  const { loadTeachers, loading: loadingTeachers } = useExplorataions();

  useEffect(() => {
    loadRotations(setRotations);
  }, [archived]);

  const requestedTeachersRef = useRef(false);

  useEffect(() => {
    if (!open) return;
    if (teachers.length > 0) return;
    if (requestedTeachersRef.current) return;
    requestedTeachersRef.current = true;

    loadTeachers(setTeachers);
  }, [open, teachers.length, loadTeachers]);

  const openCreate = (rotation: any) => {
    setOpen({ open: true, rotation });
  };

  return (
    <Dashboard activePage={archived ? "/rotations/archive" : "/rotations"}>
      <HStack justify="space-between" wrap>
        <VStack>
          <h2
            style={{
              fontSize: "var(--text-2xl)",
              lineHeight: "var(--line-height-2xl)",
              fontWeight: "var(--font-bold)",
            }}
          >
            {archived ? "Archived Rotations" : "Rotations"}
          </h2>
          <p style={{ color: "var(--muted-foreground)" }}>
            {archived
              ? "View archived rotations and sessions."
              : "View rotations and sessions."}
          </p>
        </VStack>
        <ArchiveToggleButton />
      </HStack>
      {loading.loadRotations ? (
        <Skeleton style={{ width: "100%", height: "512px" }} />
      ) : rotations.rotations.length < 1 ? (
        <Empty style={{ borderColor: "var(--secondary-border)" }}>
          <EmptyHeader>
            <EmptyMedia variant="icon">
              <CalendarSync />
            </EmptyMedia>
            <EmptyTitle>
              {archived ? "No Archived Rotations" : "No Rotations Found"}
            </EmptyTitle>
            <EmptyDescription>
              {archived
                ? "There are no archived rotations."
                : "There were no rotations found. If you believe this is an error, please refresh."}
            </EmptyDescription>
          </EmptyHeader>
        </Empty>
      ) : (
        <RotationsTable
          data={rotations}
          onCreate={openCreate}
          archived={archived}
        />
      )}
      {open.rotation && (
        <CreateExplorationSheet
          open={open.open}
          onOpenChange={(open) =>
            setOpen((prev) => ({
              ...prev,
              open,
            }))
          }
          data={{
            rotations: rotations.rotations,
            sessions: rotations.sessions,
            teachers,
          }}
          loadingTeachers={loadingTeachers.loadTeachers}
          rotation={open.rotation}
        />
      )}
    </Dashboard>
  );
};

export default TeacherRotations;
